import { Component } from '@angular/core';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { LoadingIndicatorComponent, NewVersionCheckerService } from '@nittenapps/common';
import { NavigationComponent } from './main/navigation/navigation.component';

@Component({
  selector: 'app-root',
  imports: [LoadingIndicatorComponent, MatSnackBarModule, NavigationComponent],
  providers: [NewVersionCheckerService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ANA Claims';

  constructor(newVersionCheckerService: NewVersionCheckerService, snackBar: MatSnackBar) {
    newVersionCheckerService.newVersionAvailable.subscribe((newVersion) => {
      if (newVersion) {
        snackBar
          .open('Hay una nueva versión de la aplicación', 'Actualizar')
          .onAction()
          .subscribe(() => newVersionCheckerService.applyUpdate());
      }
    });
  }
}
